import AOS from 'aos';
import './utils/vh.utils.js';
import './utils/animate-on-view.utils.js';
import './utils/parallax-on-view.utils.js';

import './components/header.component.js';
import './components/uploadFile.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/vertical-accrodion.component.js';
import './components/accordion.component.js';
import './components/text-sec-rows.component.js';
import './components/aura-cursor.component.js';
import './components/parallax-vertical-animation.component.js';
import './components/select.component.js';
import './components/validation.component.js';

import './components/search-sec.component.js';
import './components/range.component.js';

import './components/sw-packages.component.js';
import './components/sw-female.component.js';
import './components/sw-events.component.js';
import './components/sw-position.component.js';
import './components/sw-reviews.component.js';
import './components/sw-quote-clients.component.js';
import './components/sw-gallery.component.js';
import './components/sw-sets-apart.component.js';
import './components/sw-our-mission.component.js';
import './components/sw-team-culture.component.js';
import './components/sw-talent-first.component.js';
import './components/sw-trusted.component.js';
import './components/sw-sponsors.component.js';
import './components/sw-global.component.js';

import './components/marquee.component.js';
import './components/trusted-marquee.component.js';


import './components/screen.component.js';

import './components/overlayScroll.component.js';
import './components/gallery.component.js';

import './libs/countUp.lib.js';


AOS.init();

window.jsScrollToEl = function jsScrollToEl(targetID) {
  let config = targetID.split('|');
  let duration = +config[1] && +config[1] !== '' ? +config[1] : 800;
  let paddingTop = +config[2] && +config[2] !== '' ? +config[2] : 0;
  let target = config[0];
  let targetElement = document.querySelector(target);

  if (targetElement) {
    let targetOffsetTop = targetElement.offsetTop - paddingTop;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: 'smooth',
    });
    return false;
  }
};

/*window.followOnHover = function followOnHover(hovered, following) {
  if(!hovered.classList.contains('is-init')) {
    hovered.classList.add('is-init');

    const onMouseMove = (event) => {
      let x = event.offsetX;
      let y = event.offsetY;

      if (event.target.classList.contains('btn')) {
        following.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%)) scale(0.5)`;
        following.style.borderWidth = '4px';
      }
    };

    const removeMouseMove = () => {
      following.style.transform = `translate(-50%, -50%) scale(1)`;
      following.style.borderWidth = '';
    };

    const onResize = () => {
      if (window.innerWidth < 1025) {
        hovered.removeEventListener('mousemove', onMouseMove);
        hovered.removeEventListener('mouseleave', removeMouseMove);
      } else {
        hovered.addEventListener('mousemove', onMouseMove);
        hovered.addEventListener('mouseleave', removeMouseMove);
      }
    };

    window.addEventListener('resize', onResize);
    onResize();

    hovered.addEventListener('mousemove', onMouseMove);
    hovered.addEventListener('mouseleave', removeMouseMove);
  }
}

const buttons = document.querySelectorAll('.btn');
if (buttons.length) {
  buttons.forEach((btn) => {
    let arrow = btn.querySelector('.btn__arrow');

    followOnHover(btn, arrow);
  });
}*/

window.initArrowButtons = function initArrowButtons() {
  const buttons = document.querySelectorAll('.btn');

  console.log('initArrowButtons')

  buttons.forEach((btn) => {
    if(!btn.classList.contains('is-init-arrow-animation')) {
      btn.classList.add('is-init-arrow-animation');

      const arrow = btn.querySelector('.btn__arrow');

      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const arrowWrap = btn.querySelector('.btn__arrow-wrap');
        const wrapRect = arrowWrap.getBoundingClientRect();

        const offsetX = x - (wrapRect.left - rect.left) - arrow.offsetWidth / 2;
        const offsetY = y - (wrapRect.top - rect.top) - arrow.offsetHeight / 2;

        arrow.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
      });

      btn.addEventListener('mouseleave', () => {
        arrow.style.transform = `translate(-12px, -50%)`;
      });
    }
  });
}

initArrowButtons();

function updateVH() {
  let vh = window.visualViewport ? window.visualViewport.height * 0.01 : window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

updateVH();

window.visualViewport?.addEventListener('resize', updateVH);
window.addEventListener('orientationchange', updateVH);



function setDVH() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--dvh', `${vh}px`);
}

setDVH();

const tiltElements = document.querySelectorAll(".js-tilt");

if (tiltElements.length > 0 && window.innerWidth > 1365) {
  VanillaTilt.init(tiltElements, {
    max: 15,
    speed: 1000,
    reset: true,
    transition: true,
    "reset-to-start": true,
    easing: "cubic-bezier(.03,.98,.52,.99)",
    glare: true,
    "max-glare": .3,
  });
}

document.querySelectorAll('.meta-input').forEach((block) => {

  const input = block.querySelector('input, textarea');

  if (!input) return;

  block.addEventListener('click', (e) => {

    if (e.target === input) return;

    input.focus();

  });

});


function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

function handleElementVisibility({ 
  selector, 
  offset = 400, 
  maxWidth = 768, 
  checkInterval = 300 
}) {
  let element = null;

  function checkPosition() {
    if (!element) {
      element = document.querySelector(selector);
      if (!element) return;
    }

    const viewportWidth = window.innerWidth;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight;
    const viewportHeight = window.innerHeight;

    const distanceToBottom = docHeight - (scrollTop + viewportHeight);

    if (viewportWidth < maxWidth && distanceToBottom < offset) {
      element.style.display = 'none';
    } else {
      element.style.display = '';
    }
  }

  const optimizedCheck = debounce(checkPosition, 100);

  window.addEventListener('scroll', optimizedCheck);
  window.addEventListener('resize', optimizedCheck);

  const observerInterval = setInterval(() => {
    if (!element) {
      element = document.querySelector(selector);
      if (element) {
        clearInterval(observerInterval);
        checkPosition();
      }
    }
  }, checkInterval);

  checkPosition();
}

document.addEventListener('DOMContentLoaded', () => {
  handleElementVisibility({
    selector: '.es-badge-container',
    offset: 470,
    maxWidth: 768
  });
});

document.querySelectorAll('.clear input[type="submit"]').forEach(input => {
  const wrapper = input.closest('.clear');

  wrapper.className = `btn-input btn pink-white-medium ${wrapper.className.replace('clear', '').trim()} clear`;

  input.classList.add('btn__text');

  const arrowWrap = document.createElement('span');
  arrowWrap.className = 'btn__arrow-wrap';
  arrowWrap.innerHTML = `
    <span class="btn__arrow">
      <i class="icon-arrow-right"></i>
    </span>
  `;

  input.insertAdjacentElement('afterend', arrowWrap);
});

// document.addEventListener('DOMContentLoaded', () => {

// });


const buttonsInput = document.querySelectorAll('.btn-input');

buttonsInput.forEach((btn) => {
  const arrow = btn.querySelector('.btn__arrow');

  btn.addEventListener('mousemove', (e) => {
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const arrowWrap = btn.querySelector('.btn__arrow-wrap');
    const wrapRect = arrowWrap.getBoundingClientRect();

    // offset внутри обертки
    const offsetX = x - (wrapRect.left - rect.left) - arrow.offsetWidth / 2;
    const offsetY = y - (wrapRect.top - rect.top) - arrow.offsetHeight / 2;

    arrow.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
  });

  btn.addEventListener('mouseleave', () => {
    arrow.style.transform = `translate(-12px, -50%)`;
  });
});


let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) {
  document.querySelector('body').classList.add('is-safari')
}



const cookiePopupButtonSelector = '.cc-nb-main-container .cc-nb-buttons-container > button, .termsfeed-com---pc-overlay > .cc-cp-foot-button > button, .termsfeed-com---pc-overlay .cc-cp-foot-button > button, .termsfeed-com---pc-dialog .cc-cp-foot-button > button, .cc-pc-container .cc-cp-foot-save';

function initCookiePopupButtons() {
  const buttons = document.querySelectorAll(cookiePopupButtonSelector);
  if (!buttons.length) return false;

  let hasNewButtons = false;

  buttons.forEach((button) => {
    if (button.dataset.cookieBtnReady === '1') return;

    button.dataset.cookieBtnReady = '1';
    button.classList.add('btn', 'pink');

    let textBlock = button.querySelector('.btn__text');
    if (!textBlock) {
      const buttonText = button.textContent.trim();
      textBlock = document.createElement('span');
      textBlock.className = 'btn__text';
      textBlock.textContent = buttonText;
      button.textContent = '';
      button.appendChild(textBlock);
    }

    const textInner = textBlock.firstElementChild;
    if (!textInner || !textInner.classList.contains('btn__text-inner')) {
      const wrappedText = document.createElement('span');
      wrappedText.className = 'btn__text-inner';

      while (textBlock.firstChild) {
        wrappedText.appendChild(textBlock.firstChild);
      }

      textBlock.appendChild(wrappedText);
    }

    let hasArrowWrap = false;
    for (let i = 0; i < button.children.length; i += 1) {
      if (button.children[i].classList.contains('btn__arrow-wrap')) {
        hasArrowWrap = true;
        break;
      }
    }

    if (!hasArrowWrap) {
      const arrowWrap = document.createElement('span');
      arrowWrap.className = 'btn__arrow-wrap';
      arrowWrap.innerHTML = '<span class="btn__arrow"><i class="icon-arrow-right"></i></span>';
      textBlock.insertAdjacentElement('afterend', arrowWrap);
    }

    hasNewButtons = true;
  });

  if (hasNewButtons) {
    initArrowButtons();
  }

  return true;
}

function hasCookiePopupButtons(node) {
  if (!(node instanceof Element)) return false;
  if (node.matches(cookiePopupButtonSelector)) return true;
  return !!node.querySelector(cookiePopupButtonSelector);
}

let isCookieButtonsInitScheduled = false;
function scheduleCookiePopupButtonsInit() {
  if (isCookieButtonsInitScheduled) return;
  isCookieButtonsInitScheduled = true;

  requestAnimationFrame(() => {
    isCookieButtonsInitScheduled = false;
    initCookiePopupButtons();
  });
}

initCookiePopupButtons();

const cookiePopupObserver = new MutationObserver((mutations) => {
  for (let i = 0; i < mutations.length; i += 1) {
    const mutation = mutations[i];
    if (!mutation.addedNodes || !mutation.addedNodes.length) continue;

    for (let j = 0; j < mutation.addedNodes.length; j += 1) {
      if (hasCookiePopupButtons(mutation.addedNodes[j])) {
        scheduleCookiePopupButtonsInit();
        return;
      }
    }
  }
});

cookiePopupObserver.observe(document.documentElement, { childList: true, subtree: true });
